export const seeMoreBtn = function() {
	const descWrapper = document.querySelector('.product-description__wrapper'),
		  seeMoreButton = document.querySelector('.product-description__see-more');
	if (!descWrapper || !seeMoreButton) return;
	if (descWrapper.clientHeight < 325) {
		seeMoreButton.style.display = 'none';
	}
	seeMoreButton.innerHTML = seeMoreButton.dataset.more;
	seeMoreButton.addEventListener('click', function() {
		descWrapper.classList.toggle('product-description__wrapper--open');

		if (descWrapper.classList.contains('product-description__wrapper--open')) {
			this.innerHTML = seeMoreButton.dataset.less
		} else {
			this.innerHTML = seeMoreButton.dataset.more;
		}
	});
}
